import React from "/vendor/react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  withMobileDialog,
} from "/vendor/@material-ui/core";

import { ButtonSet } from "/lib/component/base";
import { ConfirmAction } from "/lib/component/util";

const ConfirmYesNoDialog = ({ fullScreen, open, onConfirm, onClose }) => (
  <Dialog
    aria-labelledby="confirm-yes-no-title"
    fullScreen={fullScreen}
    maxWidth="xs"
    open={open}
    onClose={onClose}
  >
    <DialogTitle id="confirm-yes-no-title">Potwierdzenie</DialogTitle>
    <DialogContent>
      <Typography>Czy na pewno chcesz to zrobić?</Typography>
    </DialogContent>
    <DialogActions>
      <ButtonSet>
        <Button onClick={onClose}>Nie</Button>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          Tak
        </Button>
      </ButtonSet>
    </DialogActions>
  </Dialog>
);

ConfirmYesNoDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const EnhancedDialog = withMobileDialog({ breakpoint: "xs" })(ConfirmYesNoDialog);

const ConfirmYesNo = ({ children, onSubmit }) => (
  <ConfirmAction>
    {({ isOpen, open, close }) => (
      <React.Fragment>
        <EnhancedDialog
          open={isOpen}
          onClose={close}
          onConfirm={(ev) => {
            onSubmit(ev);
            close();
          }}
        />
        {children({ open, close })}
      </React.Fragment>
    )}
  </ConfirmAction>
);

ConfirmYesNo.propTypes = {
  children: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ConfirmYesNo;
